export default class DashboardService {
  constructor($q, Evento, Formacao, Investigador, Network, Orientacao, Painel, Produto, Projeto, Revista, Servico, Publicacao, Noticia) {
    this.$q = $q;
    this.Evento = Evento;
    this.Formacao = Formacao;
    this.Investigador = Investigador;
    this.Network = Network;
    this.Orientacao = Orientacao;
    this.Painel = Painel;
    this.Produto = Produto;
    this.Projeto = Projeto;
    this.Revista = Revista;
    this.Servico = Servico;
    this.Publicacao = Publicacao;
    this.Noticia = Noticia;
  }
  getEventosData = () => {
    let defer = this.$q.defer();
    this.Evento.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getFormacoesData = () => {
    let defer = this.$q.defer();
    this.Formacao.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getInvestigadoresData = () => {
    let defer = this.$q.defer();
    this.Investigador.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getNetworksData = () => {
    let defer = this.$q.defer();
    this.Network.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getOrientacoesData = () => {
    let defer = this.$q.defer();
    this.Orientacao.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getPaineisData = () => {
    let defer = this.$q.defer();
    this.Painel.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getProdutosData = () => {
    let defer = this.$q.defer();
    this.Produto.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getProjetosData = () => {
    let defer = this.$q.defer();
    this.Projeto.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getRevistasData = () => {
    let defer = this.$q.defer();
    this.Revista.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getServicosData = () => {
    let defer = this.$q.defer();
    this.Servico.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getPublicacoesData = () => {
    let defer = this.$q.defer();
    this.Publicacao.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
  getNoticiasData = () => {
    let defer = this.$q.defer();
    this.Noticia.dashboard().$promise.then(data => defer.resolve(data)).catch(error => defer.reject(error));
    return defer.promise;
  }
}

DashboardService.$inject = ['$q', 'Evento', 'Formacao', 'Investigador', 'Network', 'Orientacao', 'Painel', 'Produto', 'Projeto', 'Revista', 'Servico', 'Publicacao', 'Noticia'];
